import React, { useState, useRef } from "react";
import LabPanelItemCDMQB from "./Components/LabPanelItem/Labpanelitemcdmqb";
import "./Labpanelscdmqb.css";
// All classNames are suffixed with "CDMQB" so they never collide with the
// default skin's CSS if that stylesheet happens to be loaded too.

export default function LabPanelsCDMQB(props) {
  const [position, setPosition] = useState(null);
  const dragOffset = useRef(null);
  const containerRef = useRef(null);

  const startDrag = (e) => {
    if (e.target.closest("div, .labPanelsExit")) return;
    if (e.target.closest("button")) return;
    const rect = containerRef.current.getBoundingClientRect();
    dragOffset.current = { x: e.clientX - rect.left, y: e.clientY - rect.top };
    e.currentTarget.setPointerCapture(e.pointerId);
    e.preventDefault();
  };

  const drag = (e) => {
    if (!dragOffset.current) return;
    setPosition({
      x: e.clientX - dragOffset.current.x,
      y: e.clientY - dragOffset.current.y,
    });
  };

  const endDrag = () => {
    dragOffset.current = null;
  };

  return (
    <div
      className={`labPanelsPageWrapperCDMQB ${props.displayLabPanels ? "" : "hideLabPanelsPopupCDMQB"}`}
    >
      <div className="labPanelsBackdropCDMQB" onClick={props.closeLabPanels} />
      <div
        ref={containerRef}
        className="labPanelsContainerCDMQB"
        style={
          position
            ? { left: position.x, top: position.y, transform: "none" }
            : undefined
        }
      >
        <div
          className="labPanelsHeaderWrapperCDMQB"
          onPointerDown={startDrag}
          onPointerMove={drag}
          onPointerUp={endDrag}
          onPointerCancel={endDrag}
        >
          <div className="labPanelsHeaderTitleCDMQB">
            <img
              className="labPanelsHeaderIconCDMQB"
              src="/exhibit.png"
              alt=""
              draggable={false}
            />
            <h4 className="labPanelsHeaderCDMQB">Lab Panels</h4>
          </div>
          <div className="labPanelsExit" onClick={props.closeLabPanels}></div>
        </div>
        <div className="labPanelContentWrapperCDMQB">
          <div className="labPanelsBodyWrapperCDMQB">
            <p className="labPanelsTitleTextCDMQB">
              APPROVED LABORATORY TEST PANELS
            </p>
          </div>
          <LabPanelItemCDMQB
            title={"Arterial Blood Gases"}
            contents={["pH", "PO2", "PCO2", "Bicarbonate", "Oxygen saturation"]}
          />
          <LabPanelItemCDMQB
            title={"Basic Metabolic Panel"}
            contents={[
              "BUN",
              "Creatinine",
              "Glucose",
              "Sodium",
              "Chloride",
              "Potassium",
              "Bicarbonate",
            ]}
          />
          <LabPanelItemCDMQB
            title={"Complete Blood Count"}
            contents={[
              "Leukocyte count",
              "Erythrocyte count",
              "Hemoglobin",
              "Hematocrit",
              "Mean corpuscular volume",
              "Mean corpuscular hemoglobin",
              "Mean corpuscular hemoglobin concentration",
              "Red blood cell distribution width",
              "Platelet count",
              "Differential",
            ]}
            indentedContents={[
              "Band neutrophils",
              "Segmented neutrophils",
              "Lymphocytes",
              "Monocytes",
              "Eosinophils",
              "Basophils",
            ]}
          />
          <LabPanelItemCDMQB
            title={"Electrolyte Panel"}
            contents={["Sodium", "Chloride", "Potassium", "Bicarbonate"]}
          />
          <LabPanelItemCDMQB
            title={"Hepatic Panel"}
            contents={[
              "Aspartate aminotransferase",
              "Alanine aminotransferase",
              "Alkaline phosphatase",
              "Total bilirubin",
              "Direct bilirubin",
            ]}
          />
          <LabPanelItemCDMQB
            title={"Lipid Panel"}
            contents={[
              "Total cholesterol",
              "HDL cholesterol",
              "LDL cholesterol",
              "Triglycerides",
            ]}
          />
          <LabPanelItemCDMQB
            title={"Serum Immunoglobulins"}
            contents={["IgA", "IgD", "IgE", "IgG", "IgM"]}
          />
          <LabPanelItemCDMQB
            title={"Urinalysis"}
            contents={[
              "pH",
              "Specific gravity",
              "Protein",
              "Glucose",
              "Ketones",
              "Bilirubin",
              "Nitrites",
              "Leukocyte esterase",
              "Blood",
            ]}
          />
        </div>
      </div>
    </div>
  );
}
